export default "__VITE_ASSET__BkaRiymP__"